<div class="form-response-editor p-2">
	<h3 class="my-2">{{label || 'Capturar formulario'}}: {{response_info.form?.title}}</h3>
	<app-loading [is_loading]="is_loading"></app-loading>
	<div *ngIf="!is_loading">
		<div *ngIf="response_info.form?.is_response_title_required == 1" class="my-2">
			<label class="fw-bold">Título de la respuesta</label>
			<input type="text" name="response_title" [(ngModel)]="response_info.response.title" class="form-control" placeholder="Titulo de la respuesta">
		</div>
		<div *ngFor="let ai of response_info.answers; let i = index" class="my-2">
			<label class="fw-bold">
				{{ai.question.question}}<span *ngIf="ai.question.required == 1 && !isLabel(ai.question)" class="text-danger"> *</span>
			</label>
			<label *ngIf="ai.question.help" class="d-block text-muted fst-italic">{{ai.question.help}}</label>
			<ng-container *ngIf="!isOptionType(ai.question) && !isLabel(ai.question)">
				<textarea *ngIf="ai.question.type == 'textarea'" [name]="'answer'+i" [(ngModel)]="ai.answer.answer_text" class="form-control" rows="2" [required]="ai.question.required == 1"></textarea>
				<input *ngIf="ai.question.type != 'textarea'" [type]="getInputType(ai.question.type)" [name]="'answer'+i" [(ngModel)]="ai.answer.answer_text" class="form-control" [required]="ai.question.required == 1">
			</ng-container>
			<select *ngIf="ai.question.type == 'select'" [name]="'answer'+i" [(ngModel)]="ai.answer.answer_text" class="form-control" [required]="ai.question.required == 1">
				<option value="">Seleccionar...</option>
				<option *ngFor="let opt of getOptions(ai.question)" [value]="opt">{{opt}}</option>
			</select>
			<ng-container *ngIf="ai.question.type == 'checkbox'">
				<div *ngFor="let opt of getOptions(ai.question); let oi = index" class="form-check">
					<input class="form-check-input" type="checkbox" [id]="'answer'+i+'_'+oi" [checked]="isChecked(i, opt)" (change)="toggleCheckbox(i, opt, $event)">
					<label class="form-check-label" [for]="'answer'+i+'_'+oi">{{opt}}</label>
				</div>
			</ng-container>
		</div>
		<div *ngIf="response_info.answers.length == 0" class="text-muted my-2">Este formulario no tiene preguntas</div>
		<div class="text-end my-3">
			<button type="button" class="btn btn-primary" (click)="accept()">Aceptar</button>
		</div>
	</div>
</div>
